import type { FormInstance } from 'antd'
import type { ComparePriceFilters, ComparePriceFiltersForm, PriceManagementMetadata } from '../types'
import type { BaseOptionType } from 'antd/es/select'

export function getGroupingOptions(options: string[]) {
  if (!options) return []
  // remove underscores and capitalize
  return options.map((option) => ({ label: formatGroupingOption(option), value: option }))
}

function formatGroupingOption(option: string) {
  return option.replaceAll('_', ' ').replace(/\b\w/g, (c) => c.toUpperCase())
}

export function getSiteOptions(options: { number: string; name: string }[]) {
  if (!options) return []
  return options
    .sort((a, b) => parseInt(a.number) - parseInt(b.number))
    .map((option) => {
      try {
        const stringOption = JSON.stringify(option)
        return {
          label: `${option.number} - ${option.name}`,
          value: stringOption,
        }
      } catch (error) {
        console.error('Error parsing site option:', option, error)
        return null
      }
    })
    .filter(Boolean) as BaseOptionType[]
}

export function parseSelectButtonText(
  groupBy: ComparePriceFilters['groupBy'],
  siteInfo: ComparePriceFilters['siteInfo']['siteOptionJSON']
) {
  if (groupBy === 'site') {
    try {
      const siteOption = JSON.parse(siteInfo)
      if (siteOption?.number && siteOption?.name) {
        return `${siteOption?.number} - ${siteOption?.name}`
      }
      return 'Site'
    } catch (error) {
      console.error('Error parsing site info:', error)
      return 'Site'
    }
  }
  if (groupBy) return groupBy.replace('_', ' ')
  // default to terminal if null
  return 'Terminal'
}

export function resetFormFields(form: FormInstance<ComparePriceFiltersForm>, filters: ComparePriceFilters) {
  let siteOption = {} as PriceManagementMetadata['stores'][number]
  try {
    if (filters.siteInfo?.siteOptionJSON) {
      siteOption = JSON.parse(filters.siteInfo?.siteOptionJSON)
    }
  } catch (error) {
    console.error('Error parsing site option:', filters.siteInfo?.siteOptionJSON, error)
  }
  form.setFieldsValue({
    groupBy: filters.groupBy,
    priceLimit: filters.priceLimit,
    siteInfo: {
      siteOptionJSON: filters.siteInfo?.siteOptionJSON && {
        label: `${siteOption?.number} - ${siteOption?.name}`,
        value: filters.siteInfo?.siteOptionJSON,
      },
      onlyInNetworkTerminals: filters.siteInfo?.onlyInNetworkTerminals,
    },
  })
}
